import {
  OpenAiWrapper as SharedOpenAiWrapper,
} from '@sofatutor/common';
import { getOpenAiBaseUrl } from '@sofatutor/common';
import FunctionPlaygroundApiWrapper from './FunctionPlaygroundApiWrapper';

/**
 * Minimal OpenAI wrapper for Function Playground, aligned with AI Toolbox.
 * - Uses backend proxy `/api/ai_proxy`
 * - Fetches an ephemeral OpenAI API key from Rails via `/api/ai_toolbox/v1/generate_open_ai_key`
 * - Avoids persisting secrets in the client; relies on server-side key management
 */
export default class FunctionPlaygroundOpenAiWrapper extends SharedOpenAiWrapper {
  constructor(initialConfig: { apiKey?: string; baseURL?: string } = {}) {
    const wrapperConfig = {
      app: 'function-playground',
      baseURL: getOpenAiBaseUrl(),
      proxyEndpoint: '/api/ai_proxy',
      keyStorageKey: 'functionPlaygroundOpenAiKey',
      railsApiWrapper: new FunctionPlaygroundApiWrapper()
    } as const;

    super(
      {
        apiKey: initialConfig.apiKey || '',
        baseURL: initialConfig.baseURL || wrapperConfig.baseURL,
        app: 'function-playground'
      },
      wrapperConfig
    );
  }
}
